import { validationConstants } from "constants/formValidation";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { IDobPage } from "types/Customize";
import { OrderType } from "types/Order/OrderType";

import { EditableField, PreviewIntro, StyledPreviewShell } from "../preview";
import { PreviewPatientDetails } from "./components/PreviewPatientDetails";
import {
  StyledDobPreview,
  StyledFooterNote,
  StyledPatientPageCard,
  StyledVerifyButton,
} from "./styled";

export function DOBPagePreview({
  customFields,
  orderType,
}: {
  customFields: IDobPage;
  orderType: OrderType;
}) {
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue(`${orderType}-headline`, customFields?.headline);
    setValue(`${orderType}-description`, customFields?.description);
    setValue(`${orderType}-verifyButton`, customFields?.verifyButton);
  }, [customFields, setValue, orderType]);

  return (
    <StyledPreviewShell data-test-id="customize-dob-preview">
      <PreviewIntro
        badge="Live preview of the patient verification page"
        title="Customize the Verify page"
      >
        Everything below is exactly what patients will see. Fields with a{" "}
        <strong>dashed outline</strong> are editable — click one, change the
        text, and hit <strong>Save Changes</strong> to publish it going forward.
      </PreviewIntro>

      <StyledPatientPageCard>
        <PreviewPatientDetails />

        <EditableField
          name={`${orderType}-headline`}
          label="HEADLINE"
          variant="headline"
          rules={{ required: validationConstants.CUSTOMIZE_FORM.HEADLINE }}
        />

        <EditableField
          name={`${orderType}-description`}
          label="DESCRIPTION"
          variant="body"
          rules={{ required: validationConstants.CUSTOMIZE_FORM.DESCRIPTION }}
        />

        <p className="text-xs font-medium line-height-2 highlighted mb-2 mt-4">
          Date of Birth
        </p>
        <StyledDobPreview className="mb-4">
          <i className="pi pi-calendar" />
          mm/dd/yyyy
        </StyledDobPreview>

        <EditableField
          name={`${orderType}-verifyButton`}
          label="VERIFY BUTTON"
          variant="buttonLabel"
          container={StyledVerifyButton}
          onDark
          rules={{ required: validationConstants.CUSTOMIZE_FORM.VERIFY_BUTTON }}
        />

        <StyledFooterNote>
          Thousands of patients have used Clear to reduce their medical bills
          and you can too.
        </StyledFooterNote>
      </StyledPatientPageCard>
    </StyledPreviewShell>
  );
}
